import React from "react";

import { JobRunner } from "@/lib/jobs/job-runner";
import { useJobHandlersStore } from "@/stores/job-handlers";
import {useJobsStore} from "@/stores/jobs";

export function AppJobsLayer({ children }: { children: React.ReactNode }) {
  const handlersByType = useJobHandlersStore((state) => state.handlersByType);
  const handlers = React.useMemo(() => Object.values(handlersByType), [handlersByType]);

  React.useEffect(() => {
    useJobsStore.getState().clearDoneJobs();
  }, []);

  return <JobRunner handlers={handlers}>{children}</JobRunner>;
}
